import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app-module';
import { Amplify } from 'aws-amplify';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { environment } from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: environment.production ? undefined : 'dev',
    tracesSampleRate: environment.sentryTracesSampleRate,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: false,
  });
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognitoUserPoolId,
      userPoolClientId: environment.cognitoClientId,
    }
  }
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

platformBrowser().bootstrapModule(AppModule, {
  
})
  .catch(err => console.error(err));

